import type { PillTone } from "@/shared/ui";

/** Map an order status to a pill tone (web/design.md §8). */
export function orderTone(status: string): PillTone {
  switch (status) {
    case "paid":
      return "ok";
    case "created":
      return "pending";
    case "failed":
    case "closed":
      return "error";
    default:
      return "neutral";
  }
}

/** i18n key for an order status — render through t(). */
export function orderLabelKey(status: string): string {
  switch (status) {
    case "paid":
      return "Paid";
    case "created":
      return "Awaiting payment";
    case "failed":
      return "Payment failed";
    case "closed":
      return "Closed";
    default:
      return status;
  }
}
